import { Dispatch } from 'redux';

import { fetcher } from '../../lib/request';

import { Airport } from '../../models/Flight/Airport';

export const AIRPORTS_REQUEST = 'FLIGHT_AIRPORTS_REQUEST';
export const AIRPORTS_RESPONSE = 'FLIGHT_AIRPORTS_RESPONSE';
export const AIRPORTS_ERROR = 'FLIGHT_AIRPORTS_ERROR';

export const SET_AIRPORT_FROM = 'FLIGHT_SET_AIRPORT_FROM';
export const SET_AIRPORT_TO = 'FLIGHT_SET_AIRPORT_TO';

export const RESET_AIRPORT = 'FLIGHT_RESET_AIRPORT';

export const SET_AIRPORT_DIRECT = 'FLIGHT_SET_AIRPORT_DIRECT';

export const SWAP_AIRPORTS = 'FLIGHT_SWAP_AIRPORTS';

const AVIASALES_HOST = process.env.REACT_APP_AVIASALES_HOST;
const AVIASALES_KEY = process.env.REACT_APP_AVIASALES_KEY;

export const setDirectAction = (isDirect: boolean) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_AIRPORT_DIRECT,
        isDirect
    });
};

export const swapAirportsAction = () => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SWAP_AIRPORTS
    });
};

export const setAirportAction = (airport: Airport, isEnd: boolean = false) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: isEnd ? SET_AIRPORT_TO : SET_AIRPORT_FROM,
        airport
    });
};

export const resetAirportAction = () => (dispatch: Dispatch<any>) => {
    dispatch({
        type: RESET_AIRPORT
    });
};

export const getAirportsAction = (query: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: AIRPORTS_REQUEST
    });

    try {
        const response = await fetcher(`${AVIASALES_HOST}/api/client/v1/autocomplete?q=${query}`)
            .auth(`Basic ${AVIASALES_KEY}`)
            .json();

        dispatch({
            type: AIRPORTS_RESPONSE,
            response
        });
        return response;
    } catch (error) {
        dispatch({
            type: AIRPORTS_ERROR,
            error: error
        });

        return;
    }
};



// WEBPACK FOOTER //
// ./src/actions/Flight/airports.ts